import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { EventAggregator } from "aurelia-event-aggregator";
import { Messages } from "../../constants/event-messages.constants";

//Load styles
require("./comp-button.scss");

@autoinject
@transient()
export class CompButton {

    public constructor(private element: Element, private eventAggregator: EventAggregator) { }

    @bindable
    public value: string;

    @bindable
    public identifier: string;

    @bindable
    public icon: string;

    @bindable
    public iconPosition: string = "right";

    @bindable
    public size: string = "medium";

    @bindable
    public type: string = "primary";

    @bindable
    public theme: string = "primary";

    @bindable
    public disabled: boolean;

    @bindable
    public loading: boolean;

    @bindable
    public tab: number;

    public button: HTMLElement;

    get buttonName() : string  {
        return this.identifier ?? this.value ?? this.button.innerText ?? this.functionName;
    }

    get functionName() : string {
        return this.button.parentElement?.getAttribute("click.delegate") ?? this.button.parentElement?.getAttribute("click.trigger") ?? "no_function_name"
    }

    private onClickOuterElement = (event: MouseEvent): void => {
        this.eventAggregator.publish(Messages.buttonClick, {"buttonName": this.buttonName, "functionName" : this.functionName });
        if (!this.isCurrentOrChildElement(<HTMLElement>event.target, this.button) || this.disabled || this.loading) {
            event.stopPropagation();
            event.preventDefault();
        }
    }

    private isCurrentOrChildElement(target: HTMLElement, parent: HTMLElement) {
        if (this.element == target)
            return false;

        if (target == parent)
            return true;

        return this.isCurrentOrChildElement(target.parentElement, parent);
    }

    detached() {
        this.button.removeEventListener("click", this.onClickOuterElement);
    }

    attached(): void {
        // disables TabIndex if Disabled
        if (this.disabled) {
            this.tab = -1;
        }
        this.button.addEventListener("click", this.onClickOuterElement);
    }

    disabledChanged(): void {
        if (this.disabled) {
            this.tab = -1;
        } else {
            this.tab = 0;
        }
    }
}
